import { gql } from '@apollo/client';

const GET_GUESS_WHO_ACTIVITY = gql`
  query guessWho($where: ActivityWhereInput!) {
    guessWho(where: $where) {
      title
      activityType {
        name
      }
      book {
        title
        bookCode
        characters {
          id
          character
          characterCase
          characterType
        }
      }
      rounds {
        tiles {
          audio {
            id
            description
            src
            vtt
          }
          image {
            description
            src
            correct
          }
        }
        scene {
          src
          description
        }
        question {
          id
          description
          src
          vtt
        }
        answer {
          id
          description
          src
          vtt
        }
        affirmation {
          id
          description
          src
          vtt
        }
      }
      summary {
        id
        description
        src
        vtt
      }
    }
  }
`;

export default GET_GUESS_WHO_ACTIVITY;
